import styled from 'styled-components';
import media from '../../../styles/media';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 60px;
  button {
    margin: 32px auto 0 auto;
  }
`;

export const AllBlogContainer = styled.div<{ related?: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  margin: auto;
  margin-top: 60px;

  ${(props) =>
    props.related ? 'padding: 0; margin: -8px;' : 'padding-right: 26px; padding-left: 26px;'}
  /* Lista de posts */
  > ul {
    margin: 0;
    list-style: none;
    margin-top: 12px;
    padding: 0 !important;
    width: 100%;
    display: ${(props) => (props.related ? 'flex' : 'block')};

    ${(props) =>
      props.related
        ? `
        flex-direction: column;
        li:first-child {
          margin-left: 0;
        }
        
      ${media('large')} {
        flex-direction: row;
        align-items: flex-start;
      }
    `
        : ''}
  }
  button {
    /* margin: 32px auto 0 auto; */
  }
`;
